<template>
  <iframe :src="src" frameborder="0"></iframe>
</template>

<script>
export default {
  name: "FrameView",
  props: {},
  components: {},
};
</script>

<style></style>
